import {Injectable} from '@angular/core';
// import {Headers, Http, RequestOptions, Response} from '@angular/http';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {RequestsHandler} from './requests.service';
import {Api} from '../utils';

@Injectable()
export class OrdersService {

    constructor(private _http: HttpClient, private api: Api, private handler: RequestsHandler) {
    }

    getOrders(page, size, search = '') {
        return this._http
            .get(this.api.getUrl('admin/order?search=' + search + '&page=' + page + '&size=' + size), {headers: this.handler.headers()})
            // .map(res => res.json())
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

    cancelShipment(order_id, shipment_id) {
        return this._http
            .patch(this.api.getUrl('admin/orders/' + order_id + '/shipments/' + shipment_id + '/cancel'), '',
              {headers: this.handler.headers()})
            // .map(res => res.json())
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

    cancelOrder(id) {
        return this._http
            .patch(this.api.getUrl('admin/orders/' + id + '/cancel'), '', {headers: this.handler.headers()})
            // .map(res => res.json())
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(new Error(err));
            });
    }

    setExtraCharge(order_id, data) {
        return this._http
            .post(this.api.getUrl('admin/orders/' + order_id + '/extra-charges'), JSON.stringify(data), {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(err);
            });
    }
    setApprove(order_id, ) {
        return this._http
            .post(this.api.getUrl('admin/orders/' + order_id + '/approve'), '', {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(err);
            });
    }

    markAsCreated(shipmentId, shipment_ref) {
        return this._http
            .post(this.api.getUrl('admin/shipment/' + shipmentId + '/mark-as-created'), shipment_ref, {headers: this.handler.headers()})
            .catch((err: any) => {
                this.handler.handleError(err);
                return Observable.throw(err);
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/services/orders.service.ts